import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActivationService } from '@sb-core/services/activation.service';
import { LocaleService } from '@sb-shared/services/locale.service';
import { CookieService } from 'ngx-cookie-service';
import { Language } from '@sb-shared/models/language';
import { LanguageCodeService } from '@sb-shared/services/language-code.service';
import { ToastService } from '@sb-core/services/toast.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-expired-token',
    templateUrl: './expired-token.component.html',
    styleUrl: './expired-token.component.scss',
    standalone: false
})
export class ExpiredTokenComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private activationService = inject(ActivationService);
  private toastService = inject(ToastService);
  private localeService = inject(LocaleService);
  private cookiesService = inject(CookieService);
  private languageCode = inject(LanguageCodeService);
  private cookieName = 'Anonymous_Default_Language';
  //private domainCookieName = 'Organisation_Domain';
  private defaultLanguage = 'en-gb';

  currentYear = new Date().getFullYear();
  email: string = '';
  languages: Language[];
  selectedLanguage: Language;
  orgId: number = 0;

  ngOnInit() {
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
    this.orgId = Number(this.route.snapshot.queryParamMap.get('oId') ?? 0);

    let languageCode = this.cookiesService.get(this.cookieName);
    let language = this.defaultLanguage;
    if(languageCode && languageCode != '') {
      language = JSON.parse(languageCode);
    }
    else {
      this.cookiesService.set(this.cookieName, JSON.stringify(this.defaultLanguage));
    }

    this.localeService.setOrganisationLanguage(this.orgId, language)
    .subscribe(x => {
      this.getLanguages();
    });
  }

  requestNewToken() {
    this.activationService.QueuePasswordResetCommunication(this.orgId.toString(), this.email).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.toastService.getSuccess('A new password reset email has been sent. Please check your inbox.', 'Email Sent');
        } else {
          this.toastService.getError('Could not send the password reset email.', 'Error');
        }
      },
      error: (err) => {
        this.toastService.getError('Could not send the password reset email. Please try again.', 'Error');
      }
    });
  }

  backgroundImageUrl(): string {
    return `url(${window.EveryBuddy.WebAPI}/img/backgrounds/3.png)`;
  }

  private getLanguages() {
    forkJoin([
      this.languageCode.getLanguageCodesForOrganisation(this.orgId, true)
    ]).subscribe(([languages]) => {
      this.languages = languages;
      this.selectedLanguage = this.findLanguageByCode(languages, JSON.parse(this.cookiesService.get(this.cookieName)));
    });
  }

  formatLanguage(locale: Language) {
    return locale.languageCode + '-' + locale.countryCode;
  }

  private findLanguageByCode(languages: Language[], languageCode: string): Language {
    return languages.find(language => this.formatLanguage(language) === languageCode)
      || languages.find(language => language.isDefault);
  }
}
